import CSS from 'csstype';

import * as S from './styled';

export interface BoxProps {
  children?: React.ReactNode | React.ReactNode[];
  sx?: CSS.Properties;
  flex?: boolean;
  flexDirection?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'baseline';
}

export function Box(props: BoxProps) {
  return (
    <S.Container style={props.sx} {...props}>
      {props.children}
    </S.Container>
  );
}
